import { useState } from "react"
import { useParams } from "react-router-dom"
import { Container } from "react-bootstrap"
import { Formik, Form } from "formik"
import * as Yup from "yup";
import { Input } from "../Components/Form/Form";
import { resetForm } from "../Functions/Utilities";
import Buttons from "../Components/Button/Buttons";

import DisputesHeaderLight from "../Components/DisputesHeaderLight"
import axios from "axios";

const handleSubmit = async (values, setSuccess, setError) => {
  try {
    const response = await axios.post(`${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}subscribe-confirm/`, values)

    setSuccess("Thank you for confirming your subscription!")

  } catch (error) {
    console.log(error)
    setError(error.response.data.error)

  }


}


export default function SubscriptionConfirmation() {

  const {email} = useParams()
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(null)

  return <>
    <DisputesHeaderLight/>
    <section className="py-[160px] overflow-hidden cover-background lg:py-[120px] md:py-[95px] sm:py-[80px] xs:py-[50px]">
        <Container>

            <div>
              <div className="text-[80px] mb-2 leading-[95px] text-[#ef8d23] font-bold uppercase tracking-[-7px] xl:tracking-[-4px] lg:text-[90px] md:text-[70px] md:leading-[65px] sm:text-[45px] sm:leading-[43px]">
                Confirm Subscription
              </div>

              <div className="bg-lightgray p-16 lg:mt-[35px] md:p-10">
                <Formik
                  initialValues={{ token: "", email: email}}
                  validationSchema={Yup.object().shape({
                    token: Yup.string()

                      .required("Field is required."),

                  })}
                  onSubmit={async (values, actions) => {
                    await new Promise((r) => handleSubmit(values, setSuccess, setError));
                    resetForm(actions);
                  }}
                >
                  {({ isSubmitting, status }) => (
                    <Form>
                      {error && (
                        <div
                          className="mb-3 p-3 rounded text-danger"
                          style={{ border: "2px solid red" }}
                        >
                          {error}
                        </div>
                      )}
                      {success && (
                        <div
                          className="mb-3 p-3 rounded text-[#ef8d23]"
                          style={{ border: "2px solid #ef8d23" }}
                        >
                          {success}
                        </div>
                      )}
                      <Input

                        showErrorMsg={false}
                        name="token"
                        type="text"
                        labelClass="mb-[20px]"
                        label={
                          <div className="mb-[15px]">
                            Token{" "}
                            <span className="text-[#fb4f58]">*</span>
                          </div>
                        }
                        className="py-[13px] px-[15px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                        placeholder="Enter your token"
                        data-test="token-input"
                      />


                      <Buttons

                        type="submit"
                        className="btn-fill btn-fancy w-full font-medium font-serif rounded-none uppercase"
                        themeColor="#232323"
                        color="#fff"
                        size="md"
                        title={`Confirm Subscription for ${email}`}
                      />
                    </Form>
                  )}
                </Formik>
              </div>
            </div>

        </Container>
      </section>
  </>
}
